import { fetchGetWithJSONResponse } from './api';
import { decodeGroups } from './decoder/decodeGroups';

export async function fetchGroups(baseUrlTags: string, authToken: string) {
    const rawTags = await fetchGetWithJSONResponse(baseUrlTags, `tags`, authToken);
    return decodeGroups(rawTags);
}
